import { Category } from '~/models/category/types'
import { AuditOption } from '~/models/audit/option'
import { RichTextSchema } from '~/models/rich-text/types'
import { SchemaField } from '~/models/form/types'

export interface AuditPackageResult {
  auditPackage: Record<string, any>
  schema: SchemaField[]
}

export interface AuditPackagesResult {
  packages: AuditPackage[]
  maxAllowed: number
}

export interface AuditPackage {
  category: Category
  name: string
  auditPointsCount: number
  active: boolean
  price: number
  auditOptions: AuditOption[]
  perks: string[]
  descriptionString: string
  id: number
  description: RichTextSchema
}

export enum AuditPackageOptionTypes {
  AUDIT_CATEGORY = 'audit_category',
  AUDIT_MEAN = 'audit_mean'
}
